/**
 * Customized to remove CurrentUser object from local storage for React app integration.
 */

import { useGuest } from '@/data/Content/Guest';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { logoutFetcher } from '@/data/Content/_Logout';
import { useSettings } from '@/data/Settings';
import { clearCurrentUserFromStorage } from '@/data/forReactAndMobile/SaveCurrentUser';
import { DATA_KEY_WISH_LIST } from '@/data/constants/dataKey';
import { dynamicESpotMutatorKeyMatcher } from '@/data/utils/mutatorKeyMatchers/dynamicESpotMutatorKeyMatcher';
import { personMutatorKeyMatcher } from '@/data/utils/mutatorKeyMatchers/personMutatorKeyMatcher';
import { userMutatorKeyMatcher } from '@/utils/mutatorKeyMatchers';
import { clearFacebookCAPIAttributes } from 'presentation/events/utils/facebookUtils';
import { SyntheticEvent, useCallback } from 'react';
import { mutate } from 'swr';
import { useCart } from './Cart';
export { logoutFetcher };

export const useLogout = () => {
	const { settings } = useSettings();
	const { storeId, csrSession } = settings ?? {};
	const params = useExtraRequestParameters();
	const { guestLogout } = useGuest();
	const { mutateCart } = useCart();

	const handleLogout = useCallback(
		async (props?: SyntheticEvent) => {
			props?.preventDefault();
			if (csrSession) {
				return;
			}
			try {
				await logoutFetcher(true)(storeId ?? '', { updateCookies: true }, params);
				clearCurrentUserFromStorage(process.env.NEXT_PUBLIC_REACT_APP_ROUTER_BASENAME || '');
				clearFacebookCAPIAttributes();

				await mutate(userMutatorKeyMatcher(''));
				await mutate(personMutatorKeyMatcher(DATA_KEY_WISH_LIST));
				await mutateCart(undefined, { revalidate: true });
				await mutate(dynamicESpotMutatorKeyMatcher(''), undefined);
			} catch (e) {
				guestLogout(); // call guestLogout to clear invalid cookies
				clearCurrentUserFromStorage(process.env.NEXT_PUBLIC_REACT_APP_ROUTER_BASENAME || '');
				console.error('clear current session error', e);
			}
		},
		[csrSession, storeId, params, guestLogout, mutateCart]
	);

	return {
		handleLogout,
		settings,
	};
};
